<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Nombre Bodega"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.nombre" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Código Softland"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.codigo" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.estaActivo" type="is-info">
                Est&aacute; activo?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.puedeReimprimir" type="is-info">
                Puede reimprimir picking lists?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.puedePickearVendedor" type="is-info">
                Vendedor puede pickear?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.separaPedidosPorZona" type="is-info">
                Separa pedidos por zona?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox
                v-model="model.obligaPickingCodigoBarra"
                type="is-info"
              >
                Obliga picking por c&oacute;digos de barra?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.bloqueaPickingManual" type="is-info">
                Bloquea picking manual?
              </b-checkbox>
            </b-field>
            <p v-if="bloqueoPickingCambio" class="help is-warning">
              Al cambiar esta opci&oacute;n se aplicar&aacute; a todas las zonas
              de la bodega y se perder&aacute;n las excepciones configuradas por
              zona.
            </p>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.ordenaPickingUbicacion" type="is-info">
                Ordena los ítems de pedido por su ubicación en la bodega?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.facturarDesdeMopi" type="is-info">
                Facturar desde MOPI
              </b-checkbox>
            </b-field>
          </validation-provider>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import { bodegaService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'BodegaForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    sucursal: {
      type: String,
      default: '0'
    },
    objeto: {
      type: Object,
      required: false,
      default: () => this.modeloInicial
    }
  },
  data: () => ({
    model: {},
    cargando: false
  }),
  computed: {
    bloqueoPickingCambio() {
      return (
        this.modificacion &&
        this.objeto &&
        this.model.bloqueaPickingManual !== this.objeto.bloqueaPickingManual
      )
    },
    postModel() {
      return Object.assign(this.model, { sucursalId: this.sucursal })
    }
  },
  created() {
    this.model = this.modeloInicial()
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      const self = this
      Promise.all([
        this.modificacion
          ? bodegaService.updateBodega(self.objeto.id, self.postModel)
          : bodegaService.addBodega(self.postModel)
      ])
        .then((rs) => {
          self.notificarAccionCompletada(
            `Se ${
              this.modificacion ? 'modificó' : 'agregó'
            } bodega correctamente`
          )
          self.$emit('close', true)
        })
        .catch((error) => self.procesarError(error))
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial()
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    modeloInicial() {
      return {
        id: null,
        nombre: null,
        codigo: null,
        estaActivo: false,
        puedeReimprimir: false,
        puedePickearVendedor: false,
        separaPedidosPorZona: false,
        obligaPickingCodigoBarra: false,
        bloqueaPickingManual: false,
        ordenaPickingUbicacion: false,
        facturarDesdeMopi: false
      }
    }
  }
}
</script>
